export default __webpack_public_path__ + "static/media/linkedin.c124bebf.png";